import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AppMenuItem',
  props: {
    icon: {},
    link: {},
    text: {},
    isActive: { type: Boolean },
    stackOnMobile: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const classes = {
  'app-menu-item--active': props.isActive,
  'app-menu-item--stacked': props.stackOnMobile,
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: _normalizeClass(["app-menu-item wg-no-merge", [classes, __props.icon]]),
    to: { name: __props.link }
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["app-menu-item__icon iconfont", __props.icon])
      }, null, 2),
      _createTextVNode(" " + _toDisplayString(__props.text), 1)
    ]),
    _: 1
  }, 8, ["class", "to"]))
}
}

})